var render = function render(){var _vm=this,_c=_vm._self._c;return _c('label',{staticClass:"b-contain",class:{ disabled: _vm.disabled }},[_c('input',{attrs:{"type":"checkbox","disabled":_vm.disabled},domProps:{"checked":_vm.value},on:{"input":_vm.emitValue,"click":function($event){return _vm.$emit('click')}}}),_c('div',{staticClass:"b-input"})])
}
var staticRenderFns = []

export { render, staticRenderFns }